import { EditOutlined } from '@ant-design/icons'
import { Button, InputNumber, Space } from 'antd'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { MAX_COUNT_PER_JOB, ROLE, STATUS_JOB, isJobManagerRole } from 'src/helpers/constants'
import { showMessageError } from 'src/helpers/functions'
import { useStore } from 'src/hooks'

// Phai khop updateCount o server: creator chi sua khi chua co designer nhan, admin/supporter sua khi viec chua dong
const CREATOR_EDITABLE_STATUS = [STATUS_JOB.PENDING, STATUS_JOB.NEW]
const MANAGER_EDITABLE_STATUS = [
   STATUS_JOB.PENDING,
   STATUS_JOB.NEW,
   STATUS_JOB.DOING,
   STATUS_JOB.REVIEW,
   STATUS_JOB.REJECT
]

/**
 * "N mau" trong popup chi tiet, bam but de sua. Chi nhan so nguyen 1..MAX_COUNT_PER_JOB.
 * Luu ngay khi bam Luu / Enter; server tu tinh lai tong tien va tru / hoan chenh lech cho creator.
 */
const JobDetailCount: React.FC = observer(() => {
   const { t } = useTranslation()
   const JobDetailStore = useStore('JobDetailStore')
   const JobsStore = useStore('JobsStore')
   const AuthStore = useStore('AuthStore')
   const { jobDetail } = JobDetailStore
   const role = AuthStore.data_role
   const [isEditing, setIsEditing] = useState(false)
   const [value, setValue] = useState<number | undefined>(jobDetail?.count)
   const [isSaving, setIsSaving] = useState(false)

   const canEdit = isJobManagerRole(role)
      ? MANAGER_EDITABLE_STATUS.includes(jobDetail?.status)
      : role === ROLE.CREATOR && CREATOR_EDITABLE_STATUS.includes(jobDetail?.status) && !jobDetail?.designerId

   const startEdit = () => {
      setValue(jobDetail?.count)
      setIsEditing(true)
   }

   const save = async (count: number) => {
      try {
         setIsSaving(true)
         const response = await JobDetailStore.updateCount(jobDetail?.id, count)
         if (response?.data) {
            const { totalPrice, totalActuallyReceived } = response.data
            JobsStore.action_patchJob(jobDetail?.id, { count: response.data.count, totalPrice, totalActuallyReceived })
            setIsEditing(false)
         }
      } finally {
         setIsSaving(false)
      }
   }

   const handleSave = () => {
      const count = Number(value)
      if (!Number.isInteger(count) || count < 1 || count > MAX_COUNT_PER_JOB) {
         showMessageError(`Số lượng mẫu phải là số nguyên từ 1 đến ${MAX_COUNT_PER_JOB}`)
         return
      }
      if (count === jobDetail?.count) {
         setIsEditing(false)
         return
      }
      save(count)
   }

   if (!isEditing) {
      return (
         <span>
            {jobDetail?.count} {t(GLOBAL_CLIENT.model)}
            {canEdit && (
               <EditOutlined style={{ marginLeft: 8, cursor: 'pointer', color: '#1890ff' }} onClick={startEdit} />
            )}
         </span>
      )
   }

   return (
      <Space size={4}>
         <InputNumber
            size="small"
            min={1}
            max={MAX_COUNT_PER_JOB}
            step={1}
            precision={0}
            // Chi cho go chu so -> khong nhap duoc 1.5
            parser={(text) => (text || '').replace(/\D/g, '')}
            value={value}
            onChange={(val) => setValue(typeof val === 'number' ? val : undefined)}
            onPressEnter={handleSave}
            style={{ width: 80 }}
            autoFocus
         />
         <span>{t(GLOBAL_CLIENT.model)}</span>
         <Button size="small" type="primary" loading={isSaving} onClick={handleSave}>
            {t(GLOBAL_CLIENT.save)}
         </Button>
         <Button size="small" disabled={isSaving} onClick={() => setIsEditing(false)}>
            {t(GLOBAL_CLIENT.huy)}
         </Button>
      </Space>
   )
})

export default JobDetailCount
